import React from 'react';
import SubHeaderComponent from '../../../components/header/subheader';
import '../../../assets/css/common/rank.css';

export default class YaoQingRank extends React.Component {
	constructor(){
		super();
	}
	componentDidMount(props) {
		
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	render() {
		return(
			<div className={'Rank'}>
				<SubHeaderComponent title="邀请排行版"></SubHeaderComponent>
				邀请排行版
		    </div>
		);
	}
}